import {
    SETUP,
    FETCH_LOYALTY_PROGRAMS,
    SAVE_LOYALTY_PROGRAM,
    DELETE_LOYALTY_PROGRAM,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SETUP:
            return action.payload.loyaltyApp.loyaltyPrograms;
        case FETCH_LOYALTY_PROGRAMS:
            return action.payload;
        case SAVE_LOYALTY_PROGRAM:
            if (action.meta && action.meta.loyaltyProgramId) {
                return state.map(loyaltyProgram => loyaltyProgram.id === action.meta.loyaltyProgramId ? action.payload : loyaltyProgram);
            }
            return state.concat(action.payload);
        case DELETE_LOYALTY_PROGRAM:
            return state.filter(loyaltyProgram => loyaltyProgram.id !== action.meta.loyaltyProgramId);
        default:
            return state;
    }
};
